import { useEffect, useRef, useState } from "react";
import { decodeToken, removeToken } from "./TokenUtils";

const INACTIVE_TIME = 480 * 60 * 1000;  // 15 daqiiqo = 900,000 ms
const WARNING_TIME = INACTIVE_TIME - 1 * 60 * 1000;  // 1 daqiiqo ka hor = 840,000 ms
const COUNTDOWN_SECONDS = 60;  // 60 seconds countdown

export const useSessionTimeout = (token) => {

  const logoutTimer = useRef(null);
  const warningTimer = useRef(null);
  const countdownTimer = useRef(null);
  const warningActive = useRef(false); // ref for warning
  const loginPage = decodeToken(token, 'loginPage');
  const [showWarning, setShowWarning] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  const logout = () => {
    // removeToken();
    // window.location.href = `/login/${loginPage}`;
  };

  const startCountdown = () => {
    setSecondsLeft(COUNTDOWN_SECONDS);

    countdownTimer.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(countdownTimer.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const resetTimers = () => {
    // Haddii warning-ka muuqdo, activity-ga ha saameynin
    if (warningActive.current) return;

    clearTimeout(logoutTimer.current);
    clearTimeout(warningTimer.current);
    clearInterval(countdownTimer.current);

    setShowWarning(false);
    warningActive.current = false;

    warningTimer.current = setTimeout(() => {
      setShowWarning(true);
      warningActive.current = true;
      startCountdown();
    }, WARNING_TIME);

    logoutTimer.current = setTimeout(() => {
      logout();
    }, INACTIVE_TIME);
  };

  useEffect(() => {

    const events = ["mousemove","keydown","click","scroll"];

    const startSession = () => {
      resetTimers();
    };

    if (token) {
      events.forEach(e => window.addEventListener(e, resetTimers));
      startSession();
    }

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimers));
      clearTimeout(logoutTimer.current);
      clearTimeout(warningTimer.current);
      clearInterval(countdownTimer.current);
    };

  }, [token]);

  const stayLoggedIn = () => {
    setShowWarning(false);
    warningActive.current = false; // reset warning flag
    resetTimers();
  };

  return { showWarning, secondsLeft, stayLoggedIn };
};